// 2018 Topps Star Wars Finest — authored by hand (2026-08-22)
// =============================================================================
// CARDS: transcribed from the official Topps checklist PDF
// (2018-SWFinest-Checklist.pdf, 4 pages, 369 entries). The PDF is a
// three-column layout, so it was parsed by text position rather than reading
// order — reading it linearly interleaves the columns and scrambles the
// numbering. Base 1-100 and Extended 101-120 were both verified complete with
// no gaps, and DV/RO/SO each run 1-20 unbroken.
//
// Counts cross-checked against TCDB (sid 179027), which agrees exactly on
// Finest Autographs (31) and Lightsaber Hilt Medallion (35). breakninja has no
// 2018 Finest table, so the parallel ladders come from TCDB cross-checked
// against Beckett's release article; the two agree on every tier.
//
// UNNUMBERED SUB-SETS: Topps numbered none of the autographs or the medallion
// cards — the PDF lists them as bare names, and TCDB lists them as NNO. CK
// keys a card by `n`, so those four sub-sets use CK-internal sequence numbers
// (PA-n, FA-n, ROA-n, LHM-n) in the PDF's own listing order, exactly the
// convention CK already uses for sketch artists. The real identity is the
// `name`. This matters most for the medallions, where three cards share the
// description "Ahsoka Tano - Ahsoka Tano's Lightsaber, Star Wars: The Clone
// Wars" and two share the Luke Skywalker Return of the Jedi one; TCDB confirms
// those are genuinely separate cards, and the sequence numbers keep them apart.
//
// PARALLELS: the base ladder does NOT apply uniformly. TCDB records that
// Refractor, Blue /150, Green /99, Orange /25 and Black /10 cover cards 1-100
// only, while Gold /50, Red /5 and the Superfractor also cover the Extended
// Set Base Cards (101-120). Extended Base is therefore its own sub-set with
// the three-step ladder, which is what Beckett describes too.
//
// Rule 7: the Lightsaber Hilt Medallion base card is numbered /99, so that
// sub-set carries a blank-name serial slot at 99. Every other base card here
// is unnumbered. Sketches are 1/1 by design.
//
// NAMING: the 2018 checklist writes autographs as "<Signer> as <Character>",
// which is kept verbatim — it matches both the source and the convention in
// the other 2018-era CK files. One Topps typo is preserved as printed: RO-7
// reads "Chirrut imwe" with a lowercase i-circumflex, while the Rogue One
// autograph for the same character on page 3 uses the capital.
// =============================================================================

export const SETS = [
  {
    id: "base",
    type: "base",
    title: "BASE",
    parallels: [
        { id: "refractor", name: "Refractor", print_run: null, color: "#c8d8f0" },
        { id: "blue-refractor", name: "Blue Refractor", print_run: 150, color: "#2979ff" },
        { id: "green-refractor", name: "Green Refractor", print_run: 99, color: "#00e676" },
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "orange-refractor", name: "Orange Refractor", print_run: 25, color: "#ff9100" },
        { id: "black-refractor", name: "Black Refractor", print_run: 10, color: "#a8a8b4" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "1", name: "4-LOM" },
        { n: "2", name: "Aayla Secura" },
        { n: "3", name: "Admiral Ackbar" },
        { n: "4", name: "Vice Admiral Amilyn Holdo" },
        { n: "5", name: "Admiral Piett" },
        { n: "6", name: "Ahsoka Tano" },
        { n: "7", name: "Anakin Skywalker" },
        { n: "8", name: "Aurra Sing" },
        { n: "9", name: "Bail Organa" },
        { n: "10", name: "Barriss Offee" },
        { n: "11", name: "BB-8" },
        { n: "12", name: "Bib Fortuna" },
        { n: "13", name: "Bo-Katan Kryze" },
        { n: "14", name: "Boba Fett" },
        { n: "15", name: "Bossk" },
        { n: "16", name: "C-3PO" },
        { n: "17", name: "Captain Panaka" },
        { n: "18", name: "Captain Phasma" },
        { n: "19", name: "Captain Rex" },
        { n: "20", name: "Chancellor Valorum" },
        { n: "21", name: "Chewbacca" },
        { n: "22", name: "Chief Chirpa" },
        { n: "23", name: "Chopper" },
        { n: "24", name: "Cikatro Vizago" },
        { n: "25", name: "Clone Trooper" },
        { n: "26", name: "Commander Cody" },
        { n: "27", name: "Count Dooku" },
        { n: "28", name: "Darth Maul" },
        { n: "29", name: "Dengar" },
        { n: "30", name: "Darth Vader" },
        { n: "31", name: "DJ" },
        { n: "32", name: "Dr. Cornelius Evazan" },
        { n: "33", name: "Ezra Bridger" },
        { n: "34", name: "Finn" },
        { n: "35", name: "FN-2199" },
        { n: "36", name: "Gamorrean Guard" },
        { n: "37", name: "General Grievous" },
        { n: "38", name: "General Hux" },
        { n: "39", name: "General Rieekan" },
        { n: "40", name: "General Veers" },
        { n: "41", name: "Grand Admiral Thrawn" },
        { n: "42", name: "The Grand Inquisitor" },
        { n: "43", name: "Grand Moff Tarkin" },
        { n: "44", name: "Greedo" },
        { n: "45", name: "Han Solo" },
        { n: "46", name: "Hera Syndulla" },
        { n: "47", name: "Hondo Ohnaka" },
        { n: "48", name: "IG-88" },
        { n: "49", name: "Imperial Royal Guard" },
        { n: "50", name: "Imperial Stormtrooper" },
        { n: "51", name: "Jabba the Hutt" },
        { n: "52", name: "Jango Fett" },
        { n: "53", name: "Jawas" },
        { n: "54", name: "Kallus" },
        { n: "55", name: "Kanan Jarrus" },
        { n: "56", name: "Kaydel Ko Connix" },
        { n: "57", name: "Ki-Adi-Mundi" },
        { n: "58", name: "Kit Fisto" },
        { n: "59", name: "Kylo Ren" },
        { n: "60", name: "Lando Calrissian" },
        { n: "61", name: "Luke Skywalker" },
        { n: "62", name: "Luminara Unduli" },
        { n: "63", name: "Mace Windu" },
        { n: "64", name: "Maz Kanata" },
        { n: "65", name: "Mon Mothma" },
        { n: "66", name: "Nute Gunray" },
        { n: "67", name: "Obi-Wan Kenobi" },
        { n: "68", name: "Owen Lars" },
        { n: "69", name: "Plo Koon" },
        { n: "70", name: "Padmé Amidala" },
        { n: "71", name: "Poe Dameron" },
        { n: "72", name: "Poggle the Lesser" },
        { n: "73", name: "Ponda Baba" },
        { n: "74", name: "Praetorian Guard" },
        { n: "75", name: "Princess Leia Organa" },
        { n: "76", name: "Qui-Gon Jinn" },
        { n: "77", name: "R2-D2" },
        { n: "78", name: "Rey" },
        { n: "79", name: "Rose Tico" },
        { n: "80", name: "Sabé" },
        { n: "81", name: "Sabine Wren" },
        { n: "82", name: "Saesee Tiin" },
        { n: "83", name: "Savage Opress" },
        { n: "84", name: "Sebulba" },
        { n: "85", name: "Shaak Ti" },
        { n: "86", name: "Shock Trooper" },
        { n: "87", name: "Supreme Leader Snoke" },
        { n: "88", name: "Teebo" },
        { n: "89", name: "Tessek" },
        { n: "90", name: "The Emperor" },
        { n: "91", name: "TIE Fighter Pilot" },
        { n: "92", name: "Tusken Raider" },
        { n: "93", name: "Unkar Plutt" },
        { n: "94", name: "Watto" },
        { n: "95", name: "Wedge Antilles" },
        { n: "96", name: "Wicket W. Warrick" },
        { n: "97", name: "Yoda" },
        { n: "98", name: "Zam Wesell" },
        { n: "99", name: "Zeb Orrelios" },
        { n: "100", name: "Zuckuss" },
    ],
  },
  {
    id: "extended-base",
    type: "insert",
    title: "EXTENDED SET BASE CARDS",
    parallels: [
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "101", name: "Admiral Ackbar" },
        { n: "102", name: "Anakin Skywalker" },
        { n: "103", name: "Bail Organa" },
        { n: "104", name: "Boba Fett" },
        { n: "105", name: "Bossk" },
        { n: "106", name: "C-3PO" },
        { n: "107", name: "Captain Rex" },
        { n: "108", name: "Chancellor Palpatine" },
        { n: "109", name: "Chewbacca" },
        { n: "110", name: "Maul" },
        { n: "111", name: "Grand Moff Tarkin" },
        { n: "112", name: "Darth Vader" },
        { n: "113", name: "Han Solo" },
        { n: "114", name: "Jabba the Hutt" },
        { n: "115", name: "General Leia Organa" },
        { n: "116", name: "Luke Skywalker" },
        { n: "117", name: "Mon Mothma" },
        { n: "118", name: "Obi-Wan Kenobi" },
        { n: "119", name: "R2-D2" },
        { n: "120", name: "Yoda" },
    ],
  },
  {
    id: "droids-and-vehicles",
    type: "insert",
    title: "DROIDS AND VEHICLES",
    parallels: [
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "DV-1", name: "2-1B" },
        { n: "DV-2", name: "2BB-2" },
        { n: "DV-3", name: "8D8" },
        { n: "DV-4", name: "Battle Droid" },
        { n: "DV-5", name: "BB-4" },
        { n: "DV-6", name: "BB-9E" },
        { n: "DV-7", name: "C2-B5" },
        { n: "DV-8", name: "Droideka" },
        { n: "DV-9", name: "EV-9D9" },
        { n: "DV-10", name: "FX-7" },
        { n: "DV-11", name: "Imperial Mouse Droid" },
        { n: "DV-12", name: "K-OHN" },
        { n: "DV-13", name: "Magnaguard" },
        { n: "DV-14", name: "GNK Droid" },
        { n: "DV-15", name: "Probe Droid" },
        { n: "DV-16", name: "PZ-4CO" },
        { n: "DV-17", name: "R4-P17" },
        { n: "DV-18", name: "R5-D4" },
        { n: "DV-19", name: "SE-2 Worker Droid" },
        { n: "DV-20", name: "Super Battle Droid" },
    ],
  },
  {
    id: "rogue-one",
    type: "insert",
    title: "ROGUE ONE: A STAR WARS STORY",
    parallels: [
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "RO-1", name: "Admiral Raddus" },
        { n: "RO-2", name: "Baze Malbus" },
        { n: "RO-3", name: "Benthic Two Tubes" },
        { n: "RO-4", name: "Bistan" },
        { n: "RO-5", name: "Bodhi Rook" },
        { n: "RO-6", name: "Captain Cassian Andor" },
        { n: "RO-7", name: "Chirrut îmwe" },
        { n: "RO-8", name: "Corporal Ansin Thobel" },
        { n: "RO-9", name: "Darth Vader" },
        { n: "RO-10", name: "Death Trooper" },
        { n: "RO-11", name: "Director Krennic" },
        { n: "RO-12", name: "Edrio Two Tubes" },
        { n: "RO-13", name: "Galen Erso" },
        { n: "RO-14", name: "General Draven" },
        { n: "RO-15", name: "Jyn Erso" },
        { n: "RO-16", name: "K-2SO" },
        { n: "RO-17", name: "Moroff" },
        { n: "RO-18", name: "Pao" },
        { n: "RO-19", name: "Saw Gerrera" },
        { n: "RO-20", name: "Shoretrooper" },
    ],
  },
  {
    id: "solo",
    type: "insert",
    title: "SOLO: A STAR WARS STORY",
    parallels: [
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SO-1", name: "Aemon Gremm" },
        { n: "SO-2", name: "Argus \"Six Eyes\" Panox" },
        { n: "SO-3", name: "Tobias Beckett" },
        { n: "SO-4", name: "Chewbacca" },
        { n: "SO-5", name: "Dryden Vos" },
        { n: "SO-6", name: "Enfys Nest" },
        { n: "SO-7", name: "Han Solo" },
        { n: "SO-8", name: "Margo" },
        { n: "SO-9", name: "L3-37" },
        { n: "SO-10", name: "Lando Calrissian" },
        { n: "SO-11", name: "Mimban Stormtrooper" },
        { n: "SO-12", name: "Moloch" },
        { n: "SO-13", name: "Qi'ra" },
        { n: "SO-14", name: "Quay Tolsite" },
        { n: "SO-15", name: "Ralakili" },
        { n: "SO-16", name: "Range Trooper" },
        { n: "SO-17", name: "Rio Durant" },
        { n: "SO-18", name: "L.T.S.O. Falthina Sharest" },
        { n: "SO-19", name: "Val" },
        { n: "SO-20", name: "Weazel" },
    ],
  },
  {
    id: "lightsaber-hilt-medallion",
    type: "insert",
    title: "LIGHTSABER HILT MEDALLION CARDS",
    parallels: [
        { id: "base", name: "", print_run: 99, color: "#c8d8f0" },
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "orange-refractor", name: "Orange Refractor", print_run: 25, color: "#ff9100" },
        { id: "black-refractor", name: "Black Refractor", print_run: 10, color: "#a8a8b4" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "LHM-1", name: "Anakin Skywalker - Anakin Skywalker's Second Lightsaber, Star Wars: Revenge of the Sith" },
        { n: "LHM-2", name: "Luke Skywalker - Anakin Skywalker's Second Lightsaber, Star Wars: A New Hope" },
        { n: "LHM-3", name: "Luke Skywalker - Anakin Skywalker's Second Lightsaber, Star Wars: The Empire Strikes Back" },
        { n: "LHM-4", name: "Rey - Anakin Skywalker's Second Lightsaber, Star Wars: The Force Awakens" },
        { n: "LHM-5", name: "Luke Skywalker - Anakin Skywalker's Second Lightsaber, Star Wars: The Last Jedi" },
        { n: "LHM-6", name: "Darth Sidious - Darth Sidious's Lightsaber, Star Wars: Revenge of the Sith" },
        { n: "LHM-7", name: "Kylo Ren - Kylo Ren's Lightsaber, Star Wars: The Force Awakens" },
        { n: "LHM-8", name: "Kylo Ren - Kylo Ren's Lightsaber, Star Wars: The Last Jedi" },
        { n: "LHM-9", name: "Darth Vader - Darth Vader's Lightsaber, Star Wars: Revenge of the Sith" },
        { n: "LHM-10", name: "Darth Vader - Darth Vader's Lightsaber, Star Wars: Rogue One" },
        { n: "LHM-11", name: "Darth Vader - Darth Vader's Lightsaber, Star Wars: The Empire Strikes Back" },
        { n: "LHM-12", name: "Darth Maul - Darth Maul's Lightsaber, Star Wars: The Phantom Menace" },
        { n: "LHM-13", name: "Count Dooku - Count Dooku's Lightsaber, Star Wars: Attack of the Clones" },
        { n: "LHM-14", name: "Yoda - Yoda's Lightsaber, Star Wars: Attack of the Clones" },
        { n: "LHM-15", name: "Yoda - Yoda's Lightsaber, Star Wars: The Clone Wars" },
        { n: "LHM-16", name: "Mace Windu - Mace Windu's Lightsaber, Star Wars: Attack of the Clones" },
        { n: "LHM-17", name: "Qui-Gon Jinn - Qui-Gon Jinn's Lightsaber, Star Wars: The Phantom Menace" },
        { n: "LHM-18", name: "Luke Skywalker - Luke Skywalker's Lightsaber, Star Wars: Return of the Jedi" },
        { n: "LHM-19", name: "Luke Skywalker - Luke Skywalker's Lightsaber, Star Wars: Return of the Jedi" },
        { n: "LHM-20", name: "Ki-Adi-Mundi - Ki-Adi-Mundi's Lightsaber, Star Wars: The Phantom Menace" },
        { n: "LHM-21", name: "Kit Fisto - Kit Fisto's Lightsaber, Star Wars: Attack of the Clones" },
        { n: "LHM-22", name: "Ahsoka Tano - Ahsoka Tano's Lightsaber, Star Wars: The Clone Wars" },
        { n: "LHM-23", name: "Ahsoka Tano - Ahsoka Tano's Lightsaber, Star Wars: The Clone Wars" },
        { n: "LHM-24", name: "Ahsoka Tano - Ahsoka Tano's Lightsaber, Star Wars: The Clone Wars" },
        { n: "LHM-25", name: "The Grand Inquisitor - The Grand Inquisitor's Lightsaber, Star Wars Rebels" },
        { n: "LHM-26", name: "Obi-Wan Kenobi - Obi-Wan Kenobi's First Lightsaber, Star Wars: The Phantom Menace" },
        { n: "LHM-27", name: "Obi-Wan Kenobi - Obi-Wan Kenobi's Second Lightsaber, Star Wars: Attack of the Clones" },
        { n: "LHM-28", name: "Shaak Ti - Shaak Ti's Lightsaber, Star Wars: Attack of the Clones" },
        { n: "LHM-29", name: "Anakin Skywalker - The Skywalker Lightsaber, Star Wars: Revenge of the Sith" },
        { n: "LHM-30", name: "Luke Skywalker - The Skywalker Lightsaber, Star Wars: A New Hope" },
        { n: "LHM-31", name: "Finn - The Skywalker Lightsaber, Star Wars: The Force Awakens" },
        { n: "LHM-32", name: "Rey - The Skywalker Lightsaber, Star Wars: The Force Awakens" },
        { n: "LHM-33", name: "Anakin Skywalker - Anakin Skywalker's First Lightsaber, Star Wars: Attack of the Clones" },
        { n: "LHM-34", name: "Asajj Ventress - Asajj Ventress' Lightsaber, Star Wars: The Clone Wars" },
        { n: "LHM-35", name: "Barriss Offee - Asajj Ventress' Lightsaber, Star Wars: The Clone Wars" },
    ],
  },
  {
    id: "finest-autographs",
    type: "auto",
    title: "FINEST AUTOGRAPHS",
    parallels: [
        { id: "green-refractor", name: "Green Refractor", print_run: 99, color: "#00e676" },
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "orange-refractor", name: "Orange Refractor", print_run: 25, color: "#ff9100" },
        { id: "black-refractor", name: "Black Refractor", print_run: 10, color: "#a8a8b4" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "FA-1", name: "Billy Dee Williams as Lando Calrissian" },
        { n: "FA-2", name: "Jeremy Bulloch as Boba Fett" },
        { n: "FA-3", name: "Ian McDiarmid as Emperor Palpatine" },
        { n: "FA-4", name: "Ray Park as Darth Maul" },
        { n: "FA-5", name: "John Boyega as Finn" },
        { n: "FA-6", name: "Gwendoline Christie as Captain Phasma" },
        { n: "FA-7", name: "Laura Dern as Vice Admiral Holdo" },
        { n: "FA-8", name: "Amanda Lawrence as Commander D'Acy" },
        { n: "FA-9", name: "Jimmy Vee as R2-D2" },
        { n: "FA-10", name: "Tim Rose as Admiral Ackbar" },
        { n: "FA-11", name: "Hermione Corfield as Tallissan \"Tallie\" Lintra" },
        { n: "FA-12", name: "George Takei as Lok Durd" },
        { n: "FA-13", name: "Sarah Michelle Gellar as Seventh Sister" },
        { n: "FA-14", name: "Tom Kenny as Silood" },
        { n: "FA-15", name: "Hayden Christensen as Anakin Skywalker" },
        { n: "FA-16", name: "Daniel Logan as Boba Fett" },
        { n: "FA-17", name: "Temuera Morrison as Jango Fett" },
        { n: "FA-18", name: "Zac Jensen as Kit Fisto" },
        { n: "FA-19", name: "Nika Futterman as Asajj Ventress" },
        { n: "FA-20", name: "Stefan Grube as Yolo Ziff" },
        { n: "FA-21", name: "Clive Revill as The Emperor" },
        { n: "FA-22", name: "James Arnold Taylor as Obi-Wan Kenobi" },
        { n: "FA-23", name: "Freddie Prinze Jr. as Kanan Jarrus" },
        { n: "FA-24", name: "Thomas Brodie-Sangster as Petty Officer Thanisson" },
        { n: "FA-25", name: "Jerome Blake as Mas Amedda" },
        { n: "FA-26", name: "Mary Elizabeth McGlynn as Governor Arihnda Pryce" },
        { n: "FA-27", name: "Matthew Wood as General Grievous" },
        { n: "FA-28", name: "Meredith Salenger as Barriss Offee" },
        { n: "FA-29", name: "Ashley Eckstein as Ahsoka Tano" },
        { n: "FA-30", name: "Sam Witwer as Maul" },
        { n: "FA-31", name: "Dee Bradley Baker as Captain Rex" },
    ],
  },
  {
    id: "rogue-one-autographs",
    type: "auto",
    title: "ROGUE ONE: A STAR WARS STORY AUTOGRAPHS",
    parallels: [
        { id: "green-refractor", name: "Green Refractor", print_run: 99, color: "#00e676" },
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "orange-refractor", name: "Orange Refractor", print_run: 25, color: "#ff9100" },
        { id: "black-refractor", name: "Black Refractor", print_run: 10, color: "#a8a8b4" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "ROA-1", name: "Felicity Jones as Jyn Erso" },
        { n: "ROA-2", name: "Ben Mendelsohn as Director Krennic" },
        { n: "ROA-3", name: "Forest Whitaker as Saw Gerrera" },
        { n: "ROA-4", name: "Donnie Yen as Chirrut Îmwe" },
        { n: "ROA-5", name: "Riz Ahmed as Bodhi Rook" },
        { n: "ROA-6", name: "Alan Tudyk as K-2SO" },
        { n: "ROA-7", name: "Mads Mikkelsen as Galen Erso" },
        { n: "ROA-8", name: "Genevieve O'Reilly as Mon Mothma" },
        { n: "ROA-9", name: "Ben Daniels as General Merrick" },
        { n: "ROA-10", name: "Ian McElhinney as Jan Dodonna" },
        { n: "ROA-11", name: "Derek Arnold as Pao" },
        { n: "ROA-12", name: "Alistair Petrie as General Draven" },
    ],
  },
  {
    id: "prime-autographs",
    type: "auto",
    title: "PRIME AUTOGRAPHS",
    parallels: [
        { id: "black-refractor", name: "Black Refractor", print_run: 10, color: "#a8a8b4" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "PA-1", name: "Harrison Ford as Han Solo" },
        { n: "PA-2", name: "Carrie Fisher as Princess Leia Organa" },
        { n: "PA-3", name: "Peter Mayhew as Chewbacca" },
        { n: "PA-4", name: "Kenny Baker as R2-D2" },
        { n: "PA-5", name: "Anthony Daniels as C-3PO" },
        { n: "PA-6", name: "Daisy Ridley as Rey" },
        { n: "PA-7", name: "Adam Driver as Kylo Ren" },
        { n: "PA-8", name: "Andy Serkis as Supreme Leader Snoke" },
    ],
  },
  {
    id: "sketch-cards",
    type: "sketch",
    title: "SKETCH ARTISTS",
    parallels: [
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SK-1", name: "Ben AbuSaada" },
        { n: "SK-2", name: "Jason Adams" },
        { n: "SK-3", name: "Thomas Amici" },
        { n: "SK-4", name: "Colin Arthurs" },
        { n: "SK-5", name: "Laura Atkinson" },
        { n: "SK-6", name: "Kelly Baber" },
        { n: "SK-7", name: "Adam Beck" },
        { n: "SK-8", name: "Dan Bergren" },
        { n: "SK-9", name: "Brandon Blevins" },
        { n: "SK-10", name: "John Bruce" },
        { n: "SK-11", name: "Carlos Cabaleiro" },
        { n: "SK-12", name: "Neil Camera" },
        { n: "SK-13", name: "Patricio Carrasco" },
        { n: "SK-14", name: "Oscar Chavez" },
        { n: "SK-15", name: "Kevin Cleveland" },
        { n: "SK-16", name: "Sebastian Cortez" },
        { n: "SK-17", name: "Aston Cover" },
        { n: "SK-18", name: "Carolyn Craggs" },
        { n: "SK-19", name: "Kaela Croft" },
        { n: "SK-20", name: "Ryan Crosby" },
        { n: "SK-21", name: "Dan Curto" },
        { n: "SK-22", name: "Gorkem Demir" },
        { n: "SK-23", name: "Nicholas Dertinger" },
        { n: "SK-24", name: "Vincenzo D'Ippolito" },
        { n: "SK-25", name: "Dean Drummond" },
        { n: "SK-26", name: "Madison Emerick" },
        { n: "SK-27", name: "Keith Farnum" },
        { n: "SK-28", name: "Rees Finlay" },
        { n: "SK-29", name: "Ryan Finley" },
        { n: "SK-30", name: "Gerard Garcia Jr." },
        { n: "SK-31", name: "Aleksandar Gigov" },
        { n: "SK-32", name: "Mick and Matt Glebe" },
        { n: "SK-33", name: "Fredd Gorham" },
        { n: "SK-34", name: "Dan Gorman" },
        { n: "SK-35", name: "Kevin Graham" },
        { n: "SK-36", name: "Allen Grimes" },
        { n: "SK-37", name: "Ingrid Hardy" },
        { n: "SK-38", name: "Adam Harris" },
        { n: "SK-39", name: "Phil Hassewer" },
        { n: "SK-40", name: "Robert Hendrickson" },
        { n: "SK-41", name: "Rich Hennemann" },
        { n: "SK-42", name: "Jessica Hickman" },
        { n: "SK-43", name: "Matthew  Hirons" },
        { n: "SK-44", name: "Brad Hudson" },
        { n: "SK-45", name: "Darren James" },
        { n: "SK-46", name: "Mohammad Jilani" },
        { n: "SK-47", name: "Nick Justus" },
        { n: "SK-48", name: "Nathan Kennett" },
        { n: "SK-49", name: "Glen Kertes" },
        { n: "SK-50", name: "Caleb King" },
        { n: "SK-51", name: "Bryce King II" },
        { n: "SK-52", name: "Travis Kinnison" },
        { n: "SK-53", name: "Erin Lefler" },
        { n: "SK-54", name: "Eric Lehtonen" },
        { n: "SK-55", name: "Kevin Liell" },
        { n: "SK-56", name: "Jaime Lopez" },
        { n: "SK-57", name: "Matthew  Lopez" },
        { n: "SK-58", name: "Jeff Mallinson" },
        { n: "SK-59", name: "Jay Manchand" },
        { n: "SK-60", name: "Michael Mastermaker" },
        { n: "SK-61", name: "Greg Mitchell" },
        { n: "SK-62", name: "Solly Mohamed" },
        { n: "SK-63", name: "Logan Monette" },
        { n: "SK-64", name: "Ryan Olsen" },
        { n: "SK-65", name: "Jim O'Riley" },
        { n: "SK-66", name: "Ibrahim Özkan" },
        { n: "SK-67", name: "Marsha Parkins" },
        { n: "SK-68", name: "Kris Penix" },
        { n: "SK-69", name: "Darrin Pepe" },
        { n: "SK-70", name: "Mark Picirilli" },
        { n: "SK-71", name: "Brendan Purchase" },
        { n: "SK-72", name: "Brent Ragland" },
        { n: "SK-73", name: "Michelle Rayner" },
        { n: "SK-74", name: "Barry Renshaw" },
        { n: "SK-75", name: "Jamie Richards" },
        { n: "SK-76", name: "Rodney Roberts" },
        { n: "SK-77", name: "Adrian Ropp" },
        { n: "SK-78", name: "Jose Ruiz" },
        { n: "SK-79", name: "Kurt Ruskin" },
        { n: "SK-80", name: "Andrew Sanchez" },
        { n: "SK-81", name: "Brent Scotchmer" },
        { n: "SK-82", name: "Richard Serrao" },
        { n: "SK-83", name: "Anil Sharma" },
        { n: "SK-84", name: "Cyrus Sherkat" },
        { n: "SK-85", name: "Tim Shinn" },
        { n: "SK-86", name: "Shaow Siong" },
        { n: "SK-87", name: "Tod Smith" },
        { n: "SK-88", name: "Matt Soffe" },
        { n: "SK-89", name: "Matt Stewart" },
        { n: "SK-90", name: "Dave Strong" },
        { n: "SK-91", name: "Adam Talley" },
        { n: "SK-92", name: "Dan Tearle" },
        { n: "SK-93", name: "Rob Teranishi" },
        { n: "SK-94", name: "Chris Thorne" },
        { n: "SK-95", name: "Phillip Trujillo" },
        { n: "SK-96", name: "Huy Truong" },
        { n: "SK-97", name: "Wayne Tully" },
        { n: "SK-98", name: "Jeff West" },
        { n: "SK-99", name: "Trent Westbrook" },
        { n: "SK-100", name: "Eric White" },
        { n: "SK-101", name: "Gavin Williams" },
        { n: "SK-102", name: "Zach Woolsey" },
        { n: "SK-103", name: "Adam Worton" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
